import { Component } from '@angular/core';
import DateTimeService from '@app/shared/common/timing/date-time.service';
import { AppConsts } from '@shared/AppConsts';
import { AppSessionService } from '@shared/common/session/app-session.service';

@Component({
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.less'],
    selector: 'footer-bar',
    standalone: false,
})
class FooterComponent {

    constructor(
        private readonly dateTimeService: DateTimeService,
        private readonly appSessionService: AppSessionService,
    ) {
    }

    // The client and the API are separate images, so show the API version too when it differs
    // (a partial deploy) — normally both carry the same release version.
    get currentVersion(): string {
        const apiVersion = this.appSessionService.application?.version;

        if (!apiVersion || apiVersion === AppConsts.appVersion) {
            return AppConsts.appVersion;
        }

        return `${AppConsts.appVersion} · API ${apiVersion}`;
    }

    get currentYear(): number {
        return this.dateTimeService.getYear();
    }
}

export default FooterComponent;
